import React from "react";
import { GradientSpan, H1, P3 } from "../components/theme/text/Headings";
import logoImg from "../images/logo/v.png";
import download from "../images/Download.svg";
import { Blue, OffWhite, Pink, White } from "../components/theme/colors";

const Landing = () => {
  return (
    <div>
      <div
        style={{
          position: "relative",
          height: "100vh",
          backgroundColor: "#000",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          flexDirection: "column",
          textAlign: "center",
        }}
      >
        {/* Centered logo */}
        <img src={logoImg} alt="Vibe Check Logo" style={{ height: "100px" }} />
        <H1 className="mt-10" color={White}>
          Send a link. <br />{" "}
          <GradientSpan $background={Blue} $transitionBackground={Pink}>
            Discover who they really are.
          </GradientSpan>{" "}
        </H1>
        <a
          href="https://apps.apple.com/us/app/vibe-check-compatibility-quiz/id6755138167"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img
            src={download}
            alt="Download on App Store"
            style={{ height: "50px", margin: "30px 0" }}
          />
        </a>

        <div
          style={{
            position: "absolute",
            bottom: "100px",
            left: "50%",
            transform: "translateX(-50%)",
            color: White,
            fontSize: "11px",
          }}
        >
          {/* Bottom text */}
          <P3 className="mb-25">
            Made by{" "}
            <GradientSpan $background={Blue} $transitionBackground={Pink}>
              Clickbait Labs, Inc.
            </GradientSpan>{" "}
          </P3>
          <P3 className="mb-15" style={{ color: OffWhite }}>
            Contact us at{" "}
            <a
              className="text-decoration-none mr-10"
              href="mailto:support@vibecheckme.com"
              style={{
                color: OffWhite,
              }}
            >
              support@vibecheckme.com
            </a>
          </P3>
          <a
            className="text-decoration-none mr-10"
            href="https://www.vibecheckme.com/terms-of-service"
            style={{
              color: OffWhite,
            }}
          >
            Terms of Service
          </a>{" "}
          <a
            className="text-decoration-none mr-10"
            href="https://www.vibecheckme.com/privacy-policy"
            style={{
              color: OffWhite,
            }}
          >
            Privacy Policy
          </a>{" "}
        </div>
      </div>
    </div>
  );
};

export default Landing;
